import React, { useEffect, useState } from "react";
import axios from "axios";
import {
    Container,
    Typography,
    Box,
    List,
    ListItem,
    ListItemIcon,
    ListItemText,
    Divider,
    Skeleton,
    Paper,
    Breadcrumbs,
    Link
} from "@mui/material";
import FiberManualRecordIcon from "@mui/icons-material/FiberManualRecord";
import { Link as RouterLink } from "react-router-dom";

const GibNews = () => {
    const [news, setNews] = useState([]);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const fetchNews = async () => {
            try {
                const response = await axios.post(
                    `https://cors-proxy-post.onrender.com/?target=https://www.gib.gov.tr/api/gibportal/duyuru/listPublish?preview=false&page=0&size=10&sortFieldName=startdate&sortType=DESC`,
                    {
                        type: 1,
                        ilkodu: "UNIVERSAL"
                    },
                    {
                        headers: {
                            "Content-Type": "application/json"
                        }
                    }
                );
                console.log(response.data);
                const items = response.data?.resultContainer?.content || [];

                const newsItems = items.map(item => ({
                    title: item.title,
                    url: `https://www.gib.gov.tr/duyuru-arsivi/mevzuat/${item.slug}`,
                    date: item.startdate
                }));
                setNews(newsItems);
                setLoading(false);
            } catch (error) {
                console.error("GİB duyuruları yüklenirken hata oluştu:", error);
                setLoading(false);
            }
        };

        fetchNews();
    }, []);

    const renderNews = (list) => (
        <List>
            {list.map((item, index) => (
                <ListItem key={index} disableGutters sx={{ py: 1 }}>
                    <ListItemIcon>
                        <FiberManualRecordIcon sx={{ fontSize: 8, color: "#d32f2f" }} />
                    </ListItemIcon>
                    <ListItemText>
                        <a href={item.url} target="_blank" rel="noopener noreferrer"
                           style={{ textDecoration: "none", color: "#333", fontSize: "16px", lineHeight: "1.5" }}>
                            {item.title}
                        </a>
                    </ListItemText>
                </ListItem>
            ))}
        </List>
    );

    return (
        <Container maxWidth="lg" sx={{ mt: 4, mb: 4 }}>
            <Breadcrumbs aria-label="breadcrumb" sx={{ mb: 2 }}>
                <Link component={RouterLink} to="/" color="inherit">
                    Ana Sayfa
                </Link>
                <Typography color="text.primary">GİB Duyuruları</Typography>
            </Breadcrumbs>
            
            <Paper elevation={3} sx={{ p: 3, borderRadius: 2 }}>
                <Box display="flex" alignItems="center" mb={2}>
                    <img src="/gib-logo.png" alt="GİB Logo" width={40} height={40} />
                    <Typography variant="h5" color="error" fontWeight="bold" ml={2}>
                        GİB Duyuruları
                    </Typography>
                </Box>
                
                <Divider sx={{ mb: 3 }} />
                
                {loading ? (
                    <Box>
                        {[...Array(10)].map((_, index) => (
                            <Skeleton key={index} variant="text" height={40} sx={{ my: 1 }} />
                        ))}
                    </Box>
                ) : (
                    <Box>
                        {renderNews(news)}
                    </Box>
                )}
            </Paper>
        </Container>
    );
};

export default GibNews;